import request from '@/utils/request'

export default function listChatGroupByMerchant(merchantId) {
  return request({
    url: `/chatGroup/agency/listByMerchant/${merchantId}`,
    method: 'get',
  })
}
